var Product;
(function (Product) {
    Product["deals"] = "deals";
    Product["insights"] = "insights";
    Product["recognition"] = "recognition";
    Product["medical"] = "medical";
    Product["tenantWallet"] = "tenantWallet";
    Product["userWallet"] = "userWallet";
    Product["reportingV3"] = "reportingV3";
    Product["ssoOptions"] = "ssoOptions";
    Product["tenantOnboarding"] = "tenantOnboarding";
    Product["cultureHub"] = "cultureHub";
})(Product || (Product = {}));
export default Product;
